import cn from 'classnames';

import style from './Input.module.scss';

export default function Input({ id, label, required, error, wide, as: Control = 'input', className, ...rest }) {
  return (
    <div className={cn(style.fld, wide && style.wide, error && style.bad, className)}>
      <label htmlFor={id}>
        {label}
        {required && (
          <>
            {' '}
            <i>*</i>
          </>
        )}
      </label>
      <Control
        id={id}
        required={required}
        aria-invalid={error ? true : undefined}
        aria-describedby={error ? `${id}-error` : undefined}
        {...rest}
      />
      {error && (
        <p
          className={style.err}
          id={`${id}-error`}
        >
          {error}
        </p>
      )}
    </div>
  );
}
